module.exports = __webpack_public_path__ + "static/img/solutionValuePic02.021a031.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionValuePic02.png
// module id = wA6W
// module chunks = 0